module.exports = __webpack_public_path__ + "static/custom-events2-ddeff70afe43589bcca7ef01e6d0f0b1.png";